export default [
  [
    6921,
    {
      c1: "Lisoflex B.V.",
      c2: "./images/logo/Logo2.jpg",
      c3: "Binnenweg 2",
      c4: "6921 GZ  Duiven",
      c5: "0316 266 990",
      c10: "53.3",
      c11: "2496.9",
      c12: "h",
    },
  ],
  [
    42370,
    {
      c0: "fr",
      c1: "Rideaux à Lanières",
      c2: "./images/logo/Logo1.jpg",
      c3: "1295 Route de Saint Nicolas",
      c4: "42370 Saint Rirand",
      c5: "04 77 87 05 75",
      c10: "53.3",
      c11: "2496.9",
      c12: "all",
    },
  ],
];
